import { format } from 'libs/dates'
import { CheckCircleIcon, MinusCircleIcon } from '@heroicons/react/24/outline'
import { ReactNode } from 'react'
import { cn } from 'utils/style'

type LifecycleItemProps = {
	label: string
	date: string | Date | null | undefined
	details?: ReactNode
}

export const LifecycleItem = ({ label, date, details }: LifecycleItemProps) => {
	const done = !!date

	return (
		<li className={cn('flex items-center gap-3 rounded-md px-3 py-2.5', done && 'bg-muted/50')}>
			<span
				className={cn(
					'grid h-6 w-6 shrink-0 place-items-center rounded-full [&>svg]:h-3.5 [&>svg]:w-3.5 [&>svg]:stroke-2',
					done ? 'bg-success-soft text-success' : 'bg-muted text-muted-foreground'
				)}>
				{done ? <CheckCircleIcon /> : <MinusCircleIcon />}
			</span>
			<span className="min-w-0 flex-1">
				<span
					className={cn(
						'block text-[13px]',
						done ? 'font-semibold text-foreground' : 'text-muted-foreground'
					)}>
					{label}
				</span>
				{details && <span className="block text-[11px] text-muted-foreground">{details}</span>}
			</span>
			{date && (
				<span className="ml-auto shrink-0 text-[11px] tabular-nums text-muted-foreground">
					{format(new Date(date), 'dd.MM.yyyy HH:mm:ss')}
				</span>
			)}
		</li>
	)
}
